<template>
    <td-dialog :title="$t(title)" :before-close="cancel" :visible.sync="dialogLevelVisible" :width="LeveWidth + 'px'" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formInfo" ref="formInfo" :rules="rules" label-position="right" :label-width="labelWidth + 'px'" class="form">
            <el-form-item :label="$t('common.NAME')" prop="sName">
                <td-input v-model="formInfo.sName" maxlength="12"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.LEVEL')" prop="iLevel">
                <td-inputNumber v-model="formInfo.iLevel" :min="1" :max="1000"></td-inputNumber>
            </el-form-item>
            <el-form-item :label="$t('common.COLOR')" prop="sColor">
                <el-color-picker v-model="formInfo.sColor"></el-color-picker>
            </el-form-item>
            <el-form-item :label="$t('common.DESCRIPTION')" prop="sDescribe">
                <td-input v-model="formInfo.sDescribe" type="textarea" maxlength="100"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from '../assets/api.js';
export default {
    props: ['title', 'dialogLevelVisible', 'editItem', 'isAddData'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        }
    },
    computed: {
        fontsize() {
            return window.vue.$store.state.fontSize;
        }
    },
    watch: {
        //观察字体大小的变化
        fontsize: {
            immediate: true,
            handler(newVal, oldVal) {
                this.LeveWidth = 292 + (Number(newVal) == 14 ? 0 : Number(newVal) + 120);
                this.labelWidth = 59 + (Number(newVal) == 14 ? 0 : Number(newVal) + 30);
            },
            deep: true //对象内部属性的监听，关键。
        }
    },
    // 定义变量
    data() {
        let validateSName = (rule, value, callback) => {
            let param = {
                sName: value
            };
            if (!this.isAddData) {
                param.sId = this.editItem.sId;
            }
            api.checkRepeat(param, response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    callback(response.data.statusMessage);
                    this.saveLoading = false;
                    return;
                } else {
                    callback();
                }
            });
        };
        let validateILevel = (rule, value, callback) => {
            let param = {
                iLevel: value
            };
            if (!this.isAddData) {
                param.sId = this.editItem.sId;
            }
            api.checkRepeat(param, response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    callback(this.$t('pgMessage.LEVEL_EXIST_PLEASE_INPUT'));
                    this.saveLoading = false;
                    return;
                } else {
                    callback();
                }
            });
        };
        return {
            labelWidth: 52,
            LeveWidth: 292,
            // 报警级别表单信息
            formInfo: {
                sName: '',
                iLevel: 1,
                sColor: '#060606',
                sDescribe: ''
            },
            saveLoading: false,
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('regex.PLEASE_ENTER_NAME_AlARM_LEVEL'), trigger: 'blur' },
                    { min: 1, max: 12, message: this.$t('regex.PLEASE_ENTER_NAME_AlARM_LEVEL') },
                    { pattern: this.$regex.CAPTION_RULE, message: this.$t('regex.NAME_ILLEGAL_AlARM_LEVEL') },
                    { validator: validateSName, trigger: 'blur' }
                ],
                iLevel: [{ required: true, message: this.$t('error.ERROR_LEVEL_NULL'), trigger: 'blur' }, { validator: validateILevel, trigger: 'blur' }],
                sDescribe: [{ min: 1, max: 100, message: this.$t('error.ERROR_DESCRIPTION_MAX_LENGTH'), trigger: 'blur' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formInfo.sName = this.editItem.sName;
            this.formInfo.iLevel = this.editItem.iLevel;
            this.formInfo.sColor = this.editItem.sColor;
            this.formInfo.sDescribe = this.editItem.sDescribe;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.saveLoading = true;
                    let content = {
                        sId: this.isAddData ? '' : this.editItem.sId,
                        sName: this.formInfo.sName,
                        iLevel: this.formInfo.iLevel,
                        sColor: this.formInfo.sColor == null ? '' : this.formInfo.sColor,
                        sDescribe: this.formInfo.sDescribe
                    };
                    api.saveAlarmLevel(content, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('alarm/saveAlarmLevel', response.data.statusMessage);
                            this.saveLoading = false;
                            return;
                        }
                        this.saveLoading = false;
                        let message = this.$t('common.ADD_SUCCESS');
                        if (!this.isAddData) {
                            message = this.$t('common.MODIFY_SUCCESS');
                        }
                        this.$message({ showClose: true, message: message, type: 'success' });
                        this.levelDialogClose();
                    });
                }
            });
        },
        // 取消
        cancel() {
            this.$emit('levelDialogClose');
            this.$refs['formInfo'].resetFields(); // 重置表单数据
        },
        // 关闭窗口之前需要调用的方法
        levelDialogClose() {
            this.cancel();
            this.$emit('submit');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: rgb(30, 160, 255);
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
